import { render, staticRenderFns } from "./LabsList.vue?vue&type=template&id=4229efbe&"
import script from "./LabsList.vue?vue&type=script&lang=js&"
export * from "./LabsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports